// extracted by mini-css-extract-plugin
export var closeButton = "_gp-2";
export var closeButtonIcon = "_gp-3";
export var lightboxContent = "_gp-1";
export var lightboxOverlay = "_gp-0";